// extracted by mini-css-extract-plugin
module.exports = {"noProducts":"ProductRecommendationsStep_noProducts__36WfY","phoneNumber":"ProductRecommendationsStep_phoneNumber__3OsjI","wrapper":"ProductRecommendationsStep_wrapper__1PlbR"};